export default __webpack_public_path__ + "static/media/My_car_website_images-6_4.670f7ff2.webp";